import classnames from 'classnames';
import { getTrackBackground, Range } from 'react-range';
import s from './index.module.scss';

export const RangeInput = ({ value, min, max, step, className, onChange }) => (
  <div className={classnames(s.wrapper, className)}>
    <Range
      values={value}
      step={step}
      min={min}
      max={max}
      onChange={values => onChange(values[0])}
      renderTrack={({ props, children }) => (
        <div
          onMouseDown={props.onMouseDown}
          onTouchStart={props.onTouchStart}
          className={s.track_wrapper}
        >
          <div
            ref={props.ref}
            className={s.track}
            style={{
              background: getTrackBackground({
                values: [value],
                colors: ['#FFE466', '#F0F0F2'],
                min,
                max,
              }),
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={Pointer}
    />
  </div>
);

const Pointer = ({ props }) => (
  <div {...props} key={props.key} className={s.pointer} />
);
